import { render, staticRenderFns } from "./SpecialistMenu.vue?vue&type=template&id=47fb6bfc"
import script from "./SpecialistMenu.vue?vue&type=script&lang=js"
export * from "./SpecialistMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports